import { combineReducers } from 'redux';
import authReducer from './AuthReducer';

export function makeRootReducer(asyncReducers) {
    return combineReducers({
        auth: authReducer,
        ...asyncReducers
    });
}

export default makeRootReducer;
